import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Typography, Paper, Grid, Alert, Button, Dialog, DialogContent, DialogActions, CircularProgress, Avatar, TextField, MenuItem, IconButton, Tooltip, List, ListItem, ListItemText, ListItemSecondaryAction, DialogTitle, DialogContentText, Snackbar, Switch, FormControlLabel, Chip, Box } from "@mui/material";
import { createTheme } from '@mui/material/styles';
import ILog from "../../types/Log";
import LogService from "../../services/LogService";
import ConfigService from "../../services/ConfigService";
import * as Constantes from '../../common/Constantes';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import RemoveIcon from '@mui/icons-material/Remove';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import * as constantes from "../../common/Constantes";
import IEmpleado from "../../types/Empleado";
import AuthService from "../../services/AuthService";
import IOutOffice from "../../types/OutOffice";
import NoDisponibleDialog, { estadoNoDisponible } from "./NoDisponibleDialog";
import RegistroJornadaSwitch from "../jornada/RegistroJornadaSwitch";
import ConfigUtils from "../../utils/Config";
import { CONFIGTYPES } from "../../types/Config";
import IAlert from "../../types/Alert";
import ISala from "../../types/Sala";
import ColorPicker from "../utilities/ColorPicker";
import { IPlan } from "../../types/Plan";
import StripeService from "../../services/StripeService";
import { textoNoDisponible } from "../../utils/Jornada";

export interface ISimpleUser {
    _id: string;
    internalID: number;
    email: string;
    firstName: string;
    lastName: string;
    role: number;
    color: string,
    accesoApp: boolean;
    activo: boolean;
    salaId: number | null;
}



const Empleados = () => {
    const theme = createTheme();
    const history = useNavigate();

    const [alert, setAlert] = useState<IAlert>({ open: false, severity: 'info', msg: '' });
    const [empleados, setEmpleados] = useState<Array<ISimpleUser>>(ConfigUtils.getEmpleados());
    const [outOffices, setOutOffices] = useState<Array<IOutOffice>>(ConfigUtils.getOutOffices());
    const [verMas, setVerMas] = useState(false);

    const [modalNewEmpleado, setModalNewEmpleado] = useState(false);
    const [loadingNewEmpleado, setLoadingNewEmpleado] = useState(false);
    const [emailEmpleado, setEmailEmpleado] = useState<string>('');
    const [errorEmail, setErrorEmail] = useState(false);
    const [nombreEmpleado, setNombreEmpleado] = useState<string>('');
    const [errorNombre, setErrorNombre] = useState(false);
    const [apellidosEmpleado, setApellidosEmpleado] = useState<string>('');
    const [errorApellidos, setErrorApellidos] = useState(false);
    const [roleEmpleado, setRoleEmpleado] = useState<number>(1);
    const [colorEmpleado, setColorEmpleado] = useState<string>(constantes.defaultEmpleadoColor);

    const [salaIdEmpleado, setSalaIdEmpleado] = useState<number | null>(null);

    const [accesoAppEmpleado, setAccesoAppEmpleado] = useState(false);
    const [openDialogAcceso, setOpenDialogAcceso] = useState(false);
    const [openDialogQuitarAcceso, setOpenDialogQuitarAcceso] = useState(false);

    const [isEdit, setIsEdit] = useState(false);
    const [idEmpleado, setIdEmpleado] = useState<string>('');
    const [selectedEmpleado, setSelectedEmpleado] = useState<ISimpleUser>();
    const [modalDeleteEmpleado, setModalDeleteEmpleado] = useState(false);

    const [modalNewOutOffice, setModalNewOutOffice] = useState(false);
    const [selectedOutOffice, setSelectedOutOffice] = useState<IOutOffice>();
    const [modalDelete, setModalDelete] = useState(false);

    const [loading, setLoading] = useState(true);
    const [plan, setPlan] = useState<IPlan>();
    
    const roles = Object.keys(constantes.ROLES).filter((v) => isNaN(Number(v)))
    .map((rol) => {
        return {
          rol,
          id: constantes.ROLES[rol as keyof typeof constantes.ROLES],
        };
    });

    const salas: ISala[] = ConfigUtils.getSalas();

    useEffect(() => {
      const getPlan = () => {
        StripeService.getPlanData(ConfigUtils.getUserId())
        .then((response: any) => {
          setPlan(response.data);
        })
        .catch((e: any) => {
          if (e.response.status === 401) {
              localStorage.clear();
              history(constantes.R_HOME);
          } else {
              const error: ILog = { method: 'Empleados.Component.useEffect', level: 'error', message: e.message, meta: e.response };
              LogService.logError(error);
              setAlert({ open: true, severity: 'error', msg: e.response.data.message });
          }
        })
        .finally(() => {
            setLoading(false);
        });
      }

      getPlan();
    }, []);

    const handleCloseAlert = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
          return;
        }
        setAlert({ open: false, severity: 'info', msg: '' });
    };

    const closeModalNewEmpleado = () => {
        setEmailEmpleado('');
        setErrorEmail(false);
        setNombreEmpleado('');
        setErrorNombre(false);
        setApellidosEmpleado('');
        setErrorApellidos(false);
        setRoleEmpleado(1);
        setColorEmpleado(constantes.defaultEmpleadoColor);
        setSalaIdEmpleado(null);
        setAccesoAppEmpleado(false);
        setIsEdit(false);
        setIdEmpleado('');
        setLoadingNewEmpleado(false);
        setModalNewEmpleado(false);
    };

    const saveEmpleado = () => {
        if (emailEmpleado === '') setErrorEmail(true);
        if (nombreEmpleado === '') setErrorNombre(true);
        if (apellidosEmpleado === '') setErrorApellidos(true);
        if (emailEmpleado === '' || nombreEmpleado === '' || apellidosEmpleado === '') return;

        if (!constantes.Email_REGEX.test(emailEmpleado)) {
            setAlert({ open: true, severity: 'error', msg: 'El email no tiene un formato válido' });
            return;
        };

        if (emailEmpleado === empleados.find(e => e.internalID === 0)?.email) {
            setAlert({ open: true, severity: 'error', msg: 'El correo electrónico del usuario ya existe' });
            return;
        };

        if (accesoAppEmpleado) {
            setOpenDialogAcceso(true);
            return;
        }

        setLoadingNewEmpleado(true);
        const empleado: IEmpleado = {
            userId: ConfigUtils.getUserId(),
            email: emailEmpleado,
            firstName: nombreEmpleado,
            lastName: apellidosEmpleado,
            role: roleEmpleado,
            color: colorEmpleado,
            accesoApp: accesoAppEmpleado,
            salaId: salaIdEmpleado
        };

        ConfigService.createEmpleado(empleado)
            .then((response: any) => {
                const newEmpleado: ISimpleUser = response.data;
                ConfigUtils.addConfig(CONFIGTYPES.users.toString(), newEmpleado);
                const newEmpleados: ISimpleUser[] = [...empleados, newEmpleado]
                setEmpleados(newEmpleados);
                setAlert({ open: true, severity: 'success', msg: 'Empleado guardado correctamente' });
            })
            .catch((e: any) => {
                if (e.response.status === 401) {
                    localStorage.clear();
                    history(constantes.R_HOME);
                } else {
                    const error: ILog = { method: 'Empleados.Component.saveEmpleado', level: 'error', message: e.message, meta: e.response };
                    LogService.logError(error);
                    setAlert({ open: true, severity: 'error', msg: e.response.data.message });
                }
            })
            .finally(() => {
                setLoadingNewEmpleado(false);
                closeModalNewEmpleado();
            });
    };

    const setIsUpdate = (empleado: ISimpleUser) => {
        setIsEdit(true);
        setIdEmpleado(empleado._id);
        setEmailEmpleado(empleado.email);
        setNombreEmpleado(empleado.firstName);
        setApellidosEmpleado(empleado.lastName);
        setRoleEmpleado(empleado.role);
        setColorEmpleado(empleado.color);
        setAccesoAppEmpleado(empleado.accesoApp ?? false);
        setSalaIdEmpleado(empleado.salaId)
        setModalNewEmpleado(true);
    };

    const updateEmpleado = () => {
        if (nombreEmpleado === '') setErrorNombre(true);
        if (apellidosEmpleado === '') setErrorApellidos(true);
        if (nombreEmpleado === '' || apellidosEmpleado === '') return;

        //Verificamos si hay cambio de acceso a la aplicación
        if (!empleados.find(e => e._id === idEmpleado)?.accesoApp === accesoAppEmpleado) {
            if (accesoAppEmpleado) {
                setOpenDialogAcceso(true);
                return;
            } else {
                setOpenDialogQuitarAcceso(true);
                return;
            }
        }

        setLoadingNewEmpleado(true);

        if (idEmpleado === ConfigUtils.getUserId()) {
            const user = {
                firstName: nombreEmpleado,
                lastName: apellidosEmpleado,
                color: colorEmpleado,
                salaId: salaIdEmpleado
            };
            AuthService.updateUser(idEmpleado, user)
            .then((response: any) => {
                const newEmpleados: ISimpleUser[] = [response.data, ...empleados.filter((e) => e._id !== response.data._id)].sort((a: any,b: any) => {
                    return a.internalID - b.internalID;
                });;
                setEmpleados(newEmpleados);
                ConfigUtils.editConfig(CONFIGTYPES.users.toString(), response.data);
                setAlert({ open: true, severity: 'success', msg: 'Usuario actualizado correctamente' });
            })
            .catch((e: any) => {
                if (e.response.status === 401) {
                    localStorage.clear();
                    history(constantes.R_HOME);
                } else {
                    const error: ILog = { method: 'Empleados.Component.updateUser', level: 'error', message: e.message, meta: e.response };
                    LogService.logError(error);
                    setAlert({ open: true, severity: 'error', msg: e.response.data.message });
                }
            })
            .finally(() => {
                setLoadingNewEmpleado(false);
                closeModalNewEmpleado();
            });
        } else {
            const empleado: IEmpleado = {
                userId: ConfigUtils.getUserId(),
                email: emailEmpleado,
                firstName: nombreEmpleado,
                lastName: apellidosEmpleado,
                role: roleEmpleado,
                color: colorEmpleado,
                accesoApp: accesoAppEmpleado,
                salaId: salaIdEmpleado
            };

            ConfigService.updateEmpleado(idEmpleado, empleado)
            .then((response: any) => {
                const newEmpleados: ISimpleUser[] = [...empleados.filter((e) => e._id !== response.data._id), response.data].sort((a: any,b: any) => {
                    return a.internalID - b.internalID;
                });
                setEmpleados(newEmpleados);
                ConfigUtils.editConfig(CONFIGTYPES.users.toString(), response.data);
                setAlert({ open: true, severity: 'success', msg: 'Empleado actualizado correctamente' });
            })
            .catch((e: any) => {
                if (e.response.status === 401) {
                    localStorage.clear();
                    history(constantes.R_HOME);
                } else {
                    const error: ILog = { method: 'Empleados.Component.updateEmpleado', level: 'error', message: e.message, meta: e.response };
                    LogService.logError(error);
                    setAlert({ open: true, severity: 'error', msg: e.response.data.message });
                }
            })
            .finally(() => {
                setLoadingNewEmpleado(false);
                closeModalNewEmpleado();
            });
        }
    };

    const sendAcceso = (dar: boolean) => {
        setLoadingNewEmpleado(true);

        if (dar) {
            setOpenDialogAcceso(false);
            if (isEdit) {
                //Enviar email de acceso
                AuthService.createPass(emailEmpleado)
                .then((response: any) => {
                    setAlert({ open: true, severity: 'success', msg: response.data.message });
                    actualizarEmpleado(idEmpleado);
                })
                .catch ((e: any) => {
                    const error: ILog = { method: 'Empleados.Component.createPass', level: 'error', message: e.message, meta: e.response };
                    LogService.logError(error);
                    setAlert({ open: true, severity: 'error', msg: e.response.data.message });
                    setLoadingNewEmpleado(false);
                });
            } else {
                //Creamos el empleado primero
                const empleado: IEmpleado = {
                    userId: ConfigUtils.getUserId(),
                    email: emailEmpleado,
                    firstName: nombreEmpleado,
                    lastName: apellidosEmpleado,
                    role: roleEmpleado,
                    color: colorEmpleado,
                    salaId: salaIdEmpleado
                };

                ConfigService.createEmpleado(empleado)
                    .then((response: any) => {
                        const newEmpleado: ISimpleUser = response.data;
                        ConfigUtils.addConfig(CONFIGTYPES.users.toString(), newEmpleado);
                        const newEmpleados: ISimpleUser[] = [...empleados, newEmpleado]
                        setEmpleados(newEmpleados);
                        setAlert({ open: true, severity: 'success', msg: 'Empleado guardado correctamente' });
                        //Enviar email de acceso
                        AuthService.createPass(emailEmpleado)
                        .then((response: any) => {
                            setAlert({ open: true, severity: 'success', msg: response.data.message });
                            actualizarEmpleado(newEmpleado._id);
                        })
                        .catch ((e: any) => {
                            const error: ILog = { method: 'Empleados.Component.createPass', level: 'error', message: e.message, meta: e.response };
                            LogService.logError(error);
                            setAlert({ open: true, severity: 'error', msg: e.response.data.message });
                            setLoadingNewEmpleado(false);
                        });
                    })
                    .catch((e: any) => {
                        if (e.response.status === 401) {
                            localStorage.clear();
                            history(constantes.R_HOME);
                        } else {
                            const error: ILog = { method: 'Empleados.Component.createEmpleado', level: 'error', message: e.message, meta: e.response };
                            LogService.logError(error);
                            setAlert({ open: true, severity: 'error', msg: e.response.data.message });
                        }
                    })
                    .finally(() => {
                        setLoadingNewEmpleado(false);
                    });
            }
        } else {
            setOpenDialogQuitarAcceso(false);
            actualizarEmpleado(idEmpleado);
        }
    };

    const actualizarEmpleado = (id: string) => {
        const empleado: IEmpleado = {
            userId: ConfigUtils.getUserId(),
            email: emailEmpleado,
            firstName: nombreEmpleado,
            lastName: apellidosEmpleado,
            role: roleEmpleado,
            color: colorEmpleado,
            accesoApp: accesoAppEmpleado,
            salaId: salaIdEmpleado
        };
    
        ConfigService.updateEmpleado(id, empleado)
        .then((response: any) => {
            const newEmpleados: ISimpleUser[] = [...empleados.filter((e) => e._id !== response.data._id), response.data].sort((a: any,b: any) => {
                return a.internalID - b.internalID;
            });;
            setEmpleados(newEmpleados);
            ConfigUtils.editConfig(CONFIGTYPES.users.toString(), response.data);
            setAlert({ open: true, severity: 'success', msg: 'Empleado actualizado correctamente' });
        })
        .catch((e: any) => {
            if (e.response.status === 401) {
                localStorage.clear();
                history(constantes.R_HOME);
            } else {
                const error: ILog = { method: 'Empleados.Component.updateEmpleado', level: 'error', message: e.message, meta: e.response };
                LogService.logError(error);
                setAlert({ open: true, severity: 'error', msg: e.response.data.message });
            }
        })
        .finally(() => {
            setLoadingNewEmpleado(false);
            closeModalNewEmpleado();
        });
    };

    const closeModalNewOutOffice = () => {
        setModalNewOutOffice(false);
        setSelectedOutOffice(undefined);
    };

    const editOutOffice = (outOffice: IOutOffice) => {
        setSelectedOutOffice(outOffice);
        setModalNewOutOffice(true);
    };

    // El diálogo guarda y actualiza la configuración; aquí solo se refresca la lista
    const outOfficeGuardado = (outOffice: IOutOffice, esNuevo: boolean) => {
        setOutOffices(esNuevo ? [...outOffices, outOffice] : [outOffice, ...outOffices.filter((e) => e._id !== outOffice._id)]);
        setAlert({ open: true, severity: 'success', msg: esNuevo ? 'No disponible guardado correctamente' : 'No disponible actualizado correctamente' });
    };

    const deleteOutOffice = () => {
        if (!selectedOutOffice) return;
        if (!selectedOutOffice._id) return;
        
        ConfigService.deleteOutOffice(selectedOutOffice._id)
            .then((response: any) => {
                const newOutOffices: IOutOffice[] = [...outOffices.filter((e) => e._id !== selectedOutOffice._id)];
                setOutOffices(newOutOffices);
                ConfigUtils.deleteConfig(CONFIGTYPES.outoffices.toString(), selectedOutOffice._id);
                setAlert({ open: true, severity: 'success', msg: 'No disponible eliminado correctamente' });
            })
            .catch((e: any) => {
                if (e.response?.status === 401) {
                    localStorage.clear();
                    history(constantes.R_HOME);
                } else if (e.response?.status === 400) {
                    // Reglas de la API (no disponible pasado o ya empezado): se avisa, no es un error
                    setAlert({ open: true, severity: 'error', msg: e.response.data?.message || 'No se ha podido eliminar el no disponible' });
                } else {
                    const error: ILog = { method: 'Empleados.Component.deleteOutOffice', level: 'error', message: e.message, meta: e.response };
                    LogService.logError(error);
                    setAlert({ open: true, severity: 'error', msg: e.response.data.message });
                }
            })
            .finally(() => {
                setModalDelete(false);
                closeModalNewOutOffice();
            });
    };

    const deleteEmpleado = () => {
        if (!selectedEmpleado) return;
        if (!selectedEmpleado._id) return;
        
        ConfigService.deleteEmpleado(selectedEmpleado._id)
            .then((response: any) => {
                const newEmpleados: ISimpleUser[] = [response.data, ...empleados.filter((e) => e._id !== response.data._id)].sort((a: any,b: any) => {
                    return a.internalID - b.internalID;
                });;
                setEmpleados(newEmpleados);
                ConfigUtils.editConfig(CONFIGTYPES.users.toString(), response.data);
                setAlert({ open: true, severity: 'success', msg: "Empleado eliminado correctamente" });
            })
            .catch((e: any) => {
                if (e.response.status === 401) {
                    localStorage.clear();
                    history(constantes.R_HOME);
                } else {
                    const error: ILog = { method: 'Empleados.Component.deleteEmpleado', level: 'error', message: e.message, meta: e.response };
                    LogService.logError(error);
                    setAlert({ open: true, severity: 'error', msg: e.response.data.message });
                }
            })
            .finally(() => {
                setModalDeleteEmpleado(false);
                setSelectedEmpleado(undefined);
            });
    };

    try {
        const activeEmpleados = empleados.filter(e => e.activo == true);
        const canAddEmpleado = plan?.limit == null || activeEmpleados.length < plan?.limit;

        if (loading) return <CircularProgress />;
        return (
            <Grid>
                <Grid container>
                    <Grid item md={12}>
                        <Grid container spacing={2} alignItems="center">
                          {/* Fila de botones */}
                          <Grid item xs={12} md={6}>
                            <Button
                              onClick={() => setModalNewEmpleado(true)}
                              disabled={!canAddEmpleado}
                              variant="contained"
                              color="success"
                              sx={{
                                width: '100%',
                              }}
                            >
                              <Typography variant="body1" sx={{ fontSize: '15px', fontWeight: 'bold', color: 'white' }}>
                                Añadir usuario
                              </Typography>
                            </Button>
                          </Grid>                               
                          <Grid item xs={12} md={6}>
                            <Button
                              onClick={() => { setSelectedOutOffice(undefined); setModalNewOutOffice(true); }}
                              variant="contained"
                              color="success"
                              sx={{
                                width: '100%',
                              }}
                            >
                              <Typography variant="body1" sx={{ fontSize: '15px', fontWeight: 'bold', color: 'white' }}>
                                Añadir periodo no disponible
                              </Typography>
                            </Button>
                          </Grid>                               
                          {/* Fila de mensaje y contador */}
                          {plan?.limit !== null  && <Grid item xs={12}>
                            <Chip
                              label={
                                plan?.limit  !== null
                                  ? `${activeEmpleados.length} / ${plan?.limit } usuarios activos`
                                  : `${activeEmpleados.length} usuarios activos (sin límite)`
                              }
                              color={canAddEmpleado ? 'success' : 'error'}
                              sx={{ mb: 1 }}
                            />                              
                            {!canAddEmpleado && plan?.limit  !== null && (
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <WarningAmberIcon sx={{ color: '#f44336', fontSize: 20 }} />
                                <Typography variant="body2" color="error">
                                  Has alcanzado el límite de {plan?.limit } usuarios activos.
                                </Typography>
                                <Button
                                  onClick={() => {history(constantes.R_SUSCRIPCION)}}
                                  variant="text"
                                  sx={{ textTransform: 'none', color: '#1976d2', fontWeight: 'bold', p: 0, minWidth: 0 }}
                                >
                                  Mejora el plan
                                </Button>
                              </Box>
                            )}
                          </Grid>}
                        </Grid>
                        <RegistroJornadaSwitch plan={plan} onError={(msg) => setAlert({ open: true, severity: 'error', msg })} />
                        {activeEmpleados.map((empleado: ISimpleUser) => {
                            
                            const sala = empleado.salaId != null
                                ? salas.find(s => Number(s.internalID ?? NaN) === empleado.salaId)?.title ?? "Sala desconocida"
                                : "Sin sala asignada";
                            return (
                                <Paper elevation={2} sx={{ marginTop: theme.spacing(2), padding: theme.spacing(3) }} key={empleado._id}>
                                    
                                    <Grid container>
                                        <Grid item md={11} xs={11}>
                                            <Typography variant="h6" >{`${empleado.firstName} ${empleado.lastName} - ${sala}`}</Typography>
                                        </Grid>
                                        <Grid item md={1} xs={1}>
                                            <Tooltip title="EDITAR EMPLEADO" >
                                                <IconButton onClick={() => setIsUpdate(empleado)}>
                                                    <EditIcon style={{ float: 'right', cursor: 'pointer', color: 'grey' }} />
                                                </IconButton>
                                            </Tooltip>
                                            {empleado.internalID != 0 && <Tooltip title="ELIMINAR EMPLEADO" >
                                                <IconButton onClick={() => {setModalDeleteEmpleado(true); setSelectedEmpleado(empleado)}}>
                                                    <DeleteIcon style={{ float: 'right', cursor: 'pointer', color: 'grey' }} />
                                                </IconButton>
                                            </Tooltip>}
                                        </Grid>
                                        <Grid item md={4} xs={12} sx={{ paddingLeft: theme.spacing(1) }}>
                                            <Typography variant="body2" >{empleado.email}</Typography>
                                            <Typography variant="body2" >{Constantes.ROLES[empleado.role]}</Typography>
                                            <div style={{ marginTop: '5px', padding: '5px', background: '#fff', borderRadius: '1px', boxShadow: '0 0 0 1px rgba(0,0,0,.1)', display: 'inline-block' }}>
                                                <div style={{ width: '36px', height: '14px', borderRadius: '2px', background: `${empleado.color}` }} />
                                            </div>
                                        </Grid>
                                    </Grid>
                                    {outOffices.filter(e => e.especialistaId === empleado.internalID).length > 0 && 
                                    <Grid container sx={{ mt: theme.spacing(2) }}>
                                        <Grid item md={10} xs={12}>
                                            <Typography sx={{ fontWeight: 'bold' }} variant="caption" >NO DISPONIBLE</Typography>
                                            {verMas ?
                                                <Tooltip title="VER MENOS" >
                                                    <IconButton onClick={() => setVerMas(false)}>
                                                        <RemoveIcon />
                                                    </IconButton>
                                                </Tooltip>
                                            :
                                                <Tooltip title="VER TODOS" >
                                                    <IconButton onClick={() => setVerMas(true)}>
                                                        <AddIcon />
                                                    </IconButton>
                                                </Tooltip>}
                                        </Grid>
                                        <List dense>
                                        {!verMas && outOffices.filter(e => e.especialistaId === empleado.internalID && new Date(e.end).getTime() > new Date().getTime()).map((outOffice: IOutOffice) => {
                                            return (
                                                <ListItem divider key={outOffice._id}>
                                                    <ListItemText sx={{ mr: theme.spacing(6) }} primary={textoNoDisponible(outOffice.start, outOffice.end).texto} />
                                                    {estadoNoDisponible(outOffice) !== 'pasado' && 
                                                    <ListItemSecondaryAction>
                                                        <Tooltip title={estadoNoDisponible(outOffice) === 'enCurso' ? "CAMBIAR EL FIN" : "EDITAR PERIODO"} ><IconButton edge="end" onClick={() => editOutOffice(outOffice)}><EditIcon/></IconButton></Tooltip>
                                                        {estadoNoDisponible(outOffice) === 'futuro' && <Tooltip title="ELIMINAR PERIODO" ><IconButton edge="end" onClick={() => {setModalDelete(true); setSelectedOutOffice(outOffice)}}><DeleteIcon/></IconButton></Tooltip>}
                                                    </ListItemSecondaryAction>}
                                                </ListItem>
                                                );
                                        })}
                                        </List>
                                        <List dense>
                                        {verMas && outOffices.filter(e => e.especialistaId === empleado.internalID).map((outOffice: IOutOffice) => {
                                            return (
                                                <ListItem divider key={outOffice._id}>
                                                    <ListItemText sx={{ mr: theme.spacing(6) }} primary={textoNoDisponible(outOffice.start, outOffice.end).texto} />
                                                    {estadoNoDisponible(outOffice) !== 'pasado' && 
                                                    <ListItemSecondaryAction>
                                                        <Tooltip title={estadoNoDisponible(outOffice) === 'enCurso' ? "CAMBIAR EL FIN" : "EDITAR PERIODO"} ><IconButton edge="end" onClick={() => editOutOffice(outOffice)}><EditIcon/></IconButton></Tooltip>
                                                        {estadoNoDisponible(outOffice) === 'futuro' && <Tooltip title="ELIMINAR PERIODO" ><IconButton edge="end" onClick={() => {setModalDelete(true); setSelectedOutOffice(outOffice)}}><DeleteIcon/></IconButton></Tooltip>}
                                                    </ListItemSecondaryAction>}
                                                </ListItem>
                                                );
                                        })}
                                        </List>
                                    </Grid>}
                                </Paper>
                            );
                        })}
                    </Grid>
                </Grid>

                {/* AÑADIR EMPLEADO */}
                <Dialog open={modalNewEmpleado} maxWidth="lg" fullWidth onClose={closeModalNewEmpleado}>
                    <DialogContent>
                        <Typography variant="h4" sx={{ display: 'inline-flex' }}>
                            <Avatar sx={{ margin: theme.spacing(1), backgroundColor: '#2e7d32' }}><AddIcon /></Avatar><div style={{ margin: '10px auto' }}>{isEdit ? 'Editar usuario' : 'Nuevo usuario'}</div>
                        </Typography>

                        <Grid container spacing={1}>
                            <Grid item md={3} xs={12} style={{ margin: 'auto' }}>
                                <TextField value={emailEmpleado} onChange={(event) => setEmailEmpleado(event.target.value)} disabled={isEdit} variant="outlined" label="Email" margin="dense" fullWidth required autoFocus error={errorEmail} helperText={errorEmail ? "El email es obligatorio" : ""} />
                            </Grid>
                            <Grid item md={3} xs={12} style={{ margin: 'auto' }}>
                                <TextField value={nombreEmpleado} onChange={(event) => setNombreEmpleado(event.target.value)} variant="outlined" label="Nombre" margin="dense" fullWidth required error={errorNombre} helperText={errorNombre ? "El nombre es obligatorio" : ""} />
                            </Grid>
                            <Grid item md={6} xs={12} style={{ margin: 'auto' }}>
                                <TextField value={apellidosEmpleado} onChange={(event) => setApellidosEmpleado(event.target.value)} variant="outlined" label="Apellidos" margin="dense" fullWidth required error={errorApellidos} helperText={errorApellidos ? "Los apellidos son obligatorios" : ""} />
                            </Grid>

                            <Grid item md={3} xs={12}>
                                <TextField select value={roleEmpleado} disabled={isEdit && idEmpleado === ConfigUtils.getUserId()} variant="outlined" label="Rol" margin="dense" fullWidth required onChange={(event) => setRoleEmpleado(parseInt(event.target.value))} >
                                {
                                    roles.map((rol) => {
                                        return (
                                            <MenuItem key={rol.id} value={rol.id}>{rol.rol}</MenuItem>
                                        );
                                    })
                                }
                                </TextField>
                            </Grid>
                            <Grid item md={3} xs={12}>
                                <TextField 
                                    select 
                                    value={salaIdEmpleado ?? ""}
                                    variant="outlined" 
                                    label="Sala" 
                                    margin="dense" 
                                    fullWidth 
                                    onChange={(event) => {
                                        const value = event.target.value;
                                        setSalaIdEmpleado(value === "" ? null : parseInt(value));
                                    }} 
                                >
                                    <MenuItem value="">Sin sala asignada</MenuItem>
                                    {salas.map((sala: ISala) => {
                                        return (
                                            <MenuItem key={sala.internalID} value={sala.internalID!}>{sala.title}</MenuItem>
                                        );
                                    })}
                                </TextField>
                            </Grid>
                            <Grid item md={1} xs={12}>
                                <ColorPicker color={colorEmpleado} onChange={(c) => setColorEmpleado(c)} />
                            </Grid>
                            {idEmpleado != ConfigUtils.getUserId() && <Grid item md={5} xs={12} style={{ margin: 'auto', marginLeft: '15px' }}>
                                <FormControlLabel label="¿Quieres dar acceso al empleado a la aplicación?" control={<Switch checked={accesoAppEmpleado} onChange={(event) => setAccesoAppEmpleado(event.target.checked)} inputProps={{ 'aria-label': 'controlled' }} />} />
                            </Grid>}
                        </Grid>
                    </DialogContent>
                    {loadingNewEmpleado ? 
                        <Grid container>
                            <CircularProgress style={{ margin: '20px auto' }} />
                        </Grid> :
                        <DialogActions>
                            <Button onClick={isEdit ? updateEmpleado : saveEmpleado}>Guardar</Button>
                            <Button onClick={closeModalNewEmpleado}>Cancelar</Button>
                        </DialogActions>}
                </Dialog>

                {/* CONFIRMAR ACCESO A LA APP DEL EMPLEADO */}
                <Dialog open={openDialogAcceso} onClose={() => setOpenDialogAcceso(false)}>
                    <DialogTitle>ENVIAR ACCESO A LA APLICACIÓN POR EMAIL</DialogTitle>
                    <DialogContent>
                        <DialogContentText>{`¿Está seguro de que desea enviar el email de acceso a la aplicación a ${nombreEmpleado}: ${emailEmpleado}?`}</DialogContentText>
                    </DialogContent>
                    
                    <DialogActions>
                        <Button onClick={() => sendAcceso(true)} color="primary">SI</Button>
                        <Button onClick={() => setOpenDialogAcceso(false)} color="primary" autoFocus>NO</Button>
                    </DialogActions>
                </Dialog>

                {/* QUITAR ACCESO A LA APP DEL EMPLEADO */}
                <Dialog open={openDialogQuitarAcceso} onClose={() => setOpenDialogQuitarAcceso(false)}>
                    <DialogTitle>QUITAR ACCESO A LA APLICACIÓN</DialogTitle>
                    <DialogContent>
                        <DialogContentText>{`¿Está seguro de que quiere quitar el acceso a la aplicación a ${nombreEmpleado}: ${emailEmpleado}?`}</DialogContentText>
                    </DialogContent>
                    
                    <DialogActions>
                        <Button onClick={() => sendAcceso(false)} color="primary">SI</Button>
                        <Button onClick={() => setOpenDialogQuitarAcceso(false)} color="primary" autoFocus>NO</Button>
                    </DialogActions>
                </Dialog>

                {/* AÑADIR O EDITAR PERIODO NO DISPONIBLE */}
                <NoDisponibleDialog
                    open={modalNewOutOffice}
                    noDisponible={selectedOutOffice}
                    profesionales={activeEmpleados}
                    onClose={closeModalNewOutOffice}
                    onGuardado={outOfficeGuardado}
                    onError={(msg) => setAlert({ open: true, severity: 'error', msg })}
                />

                {/* ELIMINAR PERIODO NO DISPONIBLE */}
                <Dialog open={modalDelete} maxWidth="lg" onClose={() => setModalDelete(false)}>
                    <DialogTitle>ELIMINAR PERIODO</DialogTitle>
                    <DialogContent>
                        <DialogContentText>{`¿Está seguro de que desea eliminar el periodo ${selectedOutOffice ? `«${textoNoDisponible(selectedOutOffice.start, selectedOutOffice.end).texto}»` : ''}?`}</DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={deleteOutOffice} color="primary">SI</Button>
                        <Button onClick={() => setModalDelete(false)} color="primary" autoFocus>NO</Button>
                    </DialogActions>

                </Dialog>

                {/* ELIMINAR EMPLEADO */}
                <Dialog open={modalDeleteEmpleado} maxWidth="lg" onClose={() => setModalDeleteEmpleado(false)}>
                    <DialogTitle>ELIMINAR EMPLEADO</DialogTitle>
                    <DialogContent>
                        <DialogContentText>{`¿Está seguro de que desea eliminar al empleado ${selectedEmpleado?.firstName} ${selectedEmpleado?.lastName} ?`}</DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={deleteEmpleado} color="primary">SI</Button>
                        <Button onClick={() => setModalDeleteEmpleado(false)} color="primary" autoFocus>NO</Button>
                    </DialogActions>

                </Dialog>

                <Snackbar open={alert.open} autoHideDuration={6000} onClose={handleCloseAlert}>
                    <Alert variant="filled" onClose={handleCloseAlert} severity={alert.severity} sx={{ width: '100%' }}>{alert.msg}</Alert>
                </Snackbar>
            </Grid>
        );
    } catch (e: any) {
        const error: ILog = { method: 'Empleados.Component', level: 'error', message: e.message, meta: e.message };
        LogService.logError(error);
        return (
            <Alert severity="error">{e.message}</Alert>
        );
    }

};

export default Empleados;